import { render, staticRenderFns } from "./FilesField.vue?vue&type=template&id=4a790824&"
import script from "./FilesField.vue?vue&type=script&lang=js&"
export * from "./FilesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kael-cadranel/Sites/apps.chateaudeseneffe.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a790824')) {
      api.createRecord('4a790824', component.options)
    } else {
      api.reload('4a790824', component.options)
    }
    module.hot.accept("./FilesField.vue?vue&type=template&id=4a790824&", function () {
      api.rerender('4a790824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/FilesField.vue"
export default component.exports